import { connectRouter } from 'connected-react-router'
import { combineReducers } from 'redux'

import activities from './ActivitiesReducer'
import annotations from './AnnotationsReducer'
import asyncReducer from './AsyncReducer'
import bookmark from './BookmarkReducer'
import {
  bookIndex,
  bookReducer,
  currentSection,
  results,
  sectionList,
  unitDetail,
  linkedUnitDetail,
} from './BookReducer'
import draft from './DraftReducer'
import flipbook from './FlipbookReducer'
import managerReducer from './ManagerReducer'
import material from './MaterialReducer'
import currentLessonPage from './MauthorReducer'
import modalReducer from './ModalReducer'
import navBarReducer from './NavBarReducer'
import sectionsIndex from './SectionsIndexReducer'
import snackBarReducer from './SnackBarReducer'
import selectedStudent from './StudentReducer'
import templateReducer from './TemplateReducer'
import user from './UserReducer'
import userFlags from './UserFlagsReducer'
import NavV2 from './NavV2Reducer'
import history from 'store/history'

const rootReducer = combineReducers({
  activities,
  annotations,
  async: asyncReducer,
  bookIndex,
  bookmark,
  currentLessonPage,
  currentSection,
  draft,
  flipbook,
  linkedUnitDetail,
  manager: managerReducer,
  material,
  modal: modalReducer,
  navBarTop: navBarReducer,
  navV2: NavV2,
  results,
  router: connectRouter(history),
  sectionList,
  sectionsIndex,
  snackBar: snackBarReducer,
  students: selectedStudent,
  template: templateReducer,
  unitDetail,
  user,
  userBook: bookReducer,
  userFlags,
})

export default rootReducer
